export const Monogram = ({ className = "w-9 h-9", id = "ga-gold" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <defs>
      <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F3E2A9" />
        <stop offset="0.45" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#9C7A22" />
      </linearGradient>
    </defs>
    <g fill={`url(#${id})`}>
      <polygon points="4,14 24,14 24,17 20,17 41,76 37,86" />
      <polygon points="35,86 38,86 64,10 61,10" />
      <polygon points="61,10 66,10 92,83 97,83 97,86 74,86 74,83 79,83" />
      <rect x="44" y="56" width="32" height="2.2" />
      <rect x="40" y="62" width="38" height="2.2" />
      <rect x="31" y="83.8" width="12" height="2.2" />
    </g>
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <Monogram className="w-9 h-9 shrink-0" />
    {!compact && (
      <span className="flex flex-col leading-none whitespace-nowrap">
        <span className="font-cinzel text-[15px] tracking-[0.12em] text-gold-soft">GRUPO AUGUSTINIS</span>
        <span className="mt-1 text-[9px] tracking-[0.42em] text-[#C0C9DC]">DIREITO E SOLUÇÕES</span>
      </span>
    )}
  </span>
);
